import React from "react";
import SVGFoundation from "../../../svg-foundation/svg-foundation";
export default class EntertainmentLogoLegacy extends SVGFoundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            titleText: void 0,
        };
    }
    render() {
        return (React.createElement("svg", Object.assign({}, this.unhandledProps()),
            this.renderTitleText(this.props),
            React.createElement("path", { 
                /* tslint:disable-next-line */
                d: "M0 16H16V0H0V16ZM5.27755 9.23849L1.4728 6.66109H6.25941L7.81032 2.09763L9.3947 6.66109H14.1478L10.3654 9.23849L11.8494 13.3668L7.81032 10.7001L3.80474 13.3668L5.27755 9.23849Z" })));
    }
}
